import { useAuthStore, AUTH_ERROR_CODES, AUTH_ERROR_MESSAGES } from "../stores/authStore";
import { supabase } from "./supabase";

const SESSION_ERROR_PATTERN = /invalid token|session expired/i;

function isSessionExpired(error: unknown): boolean {
  const status =
    (error as { status?: number })?.status ??
    (error as { context?: { response?: { status?: number } } })?.context?.response?.status;

  const message =
    typeof error === "string"
      ? error
      : typeof (error as { message?: string })?.message === "string"
        ? (error as { message: string }).message
        : "";

  const matchesMessage = message ? SESSION_ERROR_PATTERN.test(message) : false;

  return status === 401 || matchesMessage;
}

function handleSessionExpiry(error: unknown): boolean {
  if (!isSessionExpired(error)) return false;
  const logout = useAuthStore.getState().logout;
  logout(AUTH_ERROR_CODES.TOKEN_EXPIRED);
  return true;
}

function ensureServicesSuccess<T>(data: any, error: any): T {
  if (error) {
    if (handleSessionExpiry(error)) {
      throw new Error(AUTH_ERROR_MESSAGES[AUTH_ERROR_CODES.TOKEN_EXPIRED]);
    }
    throw new Error(error.message || "Errore durante la richiesta");
  }

  if (!data?.success) {
    if (handleSessionExpiry(data?.error)) {
      throw new Error(AUTH_ERROR_MESSAGES[AUTH_ERROR_CODES.TOKEN_EXPIRED]);
    }
    throw new Error(data?.error || "Query error");
  }

  return data.data as T;
}

export async function queryServicesProtected<T>(
  token: string | null,
  action: string,
  params: Record<string, unknown> = {},
  signal?: AbortSignal
): Promise<T> {
  if (!token) {
    throw new Error("Not authenticated");
  }

  const { data, error } = await supabase.functions.invoke("services-query", {
    body: { action, params },
    headers: {
      "X-Portale-Token": token,
    },
    signal,
  });

  return ensureServicesSuccess<T>(data, error);
}
